//@flow
import * as React from 'react'
import Link from 'next/link'

import { Button } from '../index'
import { useToolsStyles } from './styles'

type ToolItem = {
  id: string,
  children: React.Node,
  title?: string,
  disabled?: boolean,
  icon?: string,
  color?: string,
  link?: string
}

type TableToolsProps = {
  items: ToolItem[]
}

const TableTools = ({ items, ...props }: TableToolsProps) => {
  const classes = useToolsStyles()

  return (
    <section className={classes.toolsWrapper} {...props}>
      {items.map(({ id, title, disabled, icon, color, children, link, ...props }) => {
        const ToolButton = (
          <Button
            key={id}
            disabled={disabled}
            iconPosition="left"
            id={id}
            title={title}
            xIcon={icon}
            xStyle={color}
            {...props}
          >
            {children}
          </Button>
        )

        return link ? (
          <Link key={link} href={link}>
            <div>{ToolButton}</div>
          </Link>
        ) : (
          ToolButton
        )
      })}
    </section>
  )
}

export default TableTools
